import React from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

  // <style>
  //       {`
  //         /* Default: no margin */
  //         .my_nav {
  //           margin-top: 0;
  //         }

  //         /* Mobile only */
  //         @media (max-width: 992px) {
  //           .my_nav {
  //             margin-top: 45px !important;
  //           }
  //         }
  //       `}
  //     </style>

const Navigation = () => {
  return (
    <Navbar bg="white" expand="lg" className="my_nav shadow-sm fixed-top" style={{ top: '40px', zIndex: 1020 }}>
      <Container>
        <Navbar.Brand as={Link} to="/" className="fw-bold text-gradient fs-3">
          WiSE
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" className="fw-semibold mx-2">Home</Nav.Link>
            <Nav.Link as={Link} to="/about" className="fw-semibold mx-2">About</Nav.Link>

            {/* Products Dropdown */}
            <NavDropdown title="Products" id="products-dropdown" className="fw-semibold mx-2">
              <NavDropdown.Item as={Link} to="/products">Dairy</NavDropdown.Item>
              <NavDropdown.Item disabled>Millets</NavDropdown.Item>
              <NavDropdown.Item disabled>Gravity Water Filter</NavDropdown.Item>
               <NavDropdown.Item disabled>Agri</NavDropdown.Item>
              <NavDropdown.Item disabled>Textiles</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={Link} to="/services" className="fw-semibold mx-2">Services</Nav.Link>
            <Nav.Link as={Link} to="/events" className="fw-semibold mx-2">Events</Nav.Link>
            <Nav.Link as={Link} to="/testimonials" className="fw-semibold mx-2">Testimonials</Nav.Link>
            <Nav.Link as={Link} to="/faq" className="fw-semibold mx-2">FAQ</Nav.Link>
            <Nav.Link as={Link} to="/outlets" className="fw-semibold mx-2">Outlets</Nav.Link>
            <Nav.Link as={Link} to="/gallery" className="fw-semibold mx-2">Gallery</Nav.Link>
            <Nav.Link as={Link} to="/contact" className="fw-semibold mx-2">Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
